import React from 'react';

import {ResizeGripIcon} from './icons';

export const ResizeHandle: React.FC<{
  onMouseDown: (e: React.MouseEvent) => void;
}> = ({onMouseDown}) => (
  <div
    onMouseDown={onMouseDown}
    className="absolute bottom-0 right-0 flex h-16 w-16 cursor-nwse-resize items-center justify-center opacity-30 hover:opacity-60">
    <ResizeGripIcon />
  </div>
);
